import { css } from '@emotion/react';

export const brandPagination = css`
    .ant-pagination {
        .ant-pagination-item,
        .ant-pagination-prev,
        .ant-pagination-next {
            min-width: 24px;
            height: 24px;
            margin-inline-end: 4px;
            border: none;
            font-family: var(--font-sans);
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            background: transparent;
        }
        .ant-pagination-item a,
        .ant-pagination-prev .ant-pagination-item-link,
        .ant-pagination-next .ant-pagination-item-link {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 0;
            font-size: 14px;
            color: var(--blue-400);
        }
        .ant-pagination-item:hover,
        .ant-pagination-prev:hover .ant-pagination-item-link,
        .ant-pagination-next:hover .ant-pagination-item-link {
            background: transparent;
        }
        .ant-pagination-item:hover a {
            color: var(--blue-500);
        }
        .ant-pagination-item-active a,
        .ant-pagination-item-active:hover a {
            font-weight: 400;
            color: var(--sand-700);
        }
        .ant-pagination-disabled .ant-pagination-item-link,
        .ant-pagination-disabled:hover .ant-pagination-item-link {
            color: var(--blue-100);
        }
        .ant-pagination-prev .anticon,
        .ant-pagination-next .anticon {
            font-size: 12px;
        }
    }
`;
